import { createSelector } from 'reselect'
import slideModeTypes from 'helpers/enums/slideModeTypes'
import searchStatuses from 'helpers/enums/storeSearchStatuses'
import flocabularyCurrentVideoSelector from 'redux/selectors/flocabulary/flocabulary_current_video_selector'
import flocabularySearchPageSelector from 'redux/selectors/flocabulary/flocabulary_search_page_selector'

const flocabularySelector = state => state.flocabulary
const getUserCanAddOrEditFlocabulary = state => state.user.extra ? state.user.extra.canAddOrEditFlocabulary : false

const creationToolContainerSelector = createSelector(
	[
		flocabularySelector,
		flocabularyCurrentVideoSelector,
		getUserCanAddOrEditFlocabulary,
		flocabularySearchPageSelector,
	],
	(
		flocabularyState,
		currentVideo,
		canAddOrEditFlocabulary,
		searchPage
	) => {
		const categoryTabs = flocabularyState.categories.map(category => ({
			tabId: category.page_name,
			tabName: `Flocabulary_Category_${category.key_name}`,
			children: category.topics.map(topic => ({
				tabId: topic.page_name,
				tabName: `Flocabulary_SubCategory_${topic.key_name}`,
			})),
		}))

		const currentVideos = flocabularyState.currentVideosIds.map( videoId => flocabularyState.videos.find( video => video.contentId === videoId ))
		return {
			flocabularyUID: flocabularyState.entityUID,
			videos: currentVideos,
			categoryTabs,
			selectedCategory: flocabularyState.category,
			fixedTitle: flocabularyState.query ? 'Flocabulary_Category_all_videos' : '',
			canEdit: canAddOrEditFlocabulary,
			shouldShowList: flocabularyState.selectedVideoId === '',
			currentVideo,
			isEdition: flocabularyState.mode === slideModeTypes.EDITION,
			canCancel: flocabularyState.mode === slideModeTypes.CREATION && currentVideo.contentId !== '',
			shouldShowNoResults: flocabularyState.search.state === searchStatuses.READY && currentVideos.length === 0,
			currentSearchQuery: flocabularyState.query,
			hasMore: searchPage.hasMore,
		}
	}
)

export default creationToolContainerSelector
